import _ from "lodash";

const defaultVatPercent = parseFloat(process.env.VUE_APP_VAT_PERCENT);

const addVat = (exlusiveAmount, vatRate) => {
    const vatPercent = vatRate ?? defaultVatPercent;

    let parsedExlusiveAmount = parseFloat(exlusiveAmount);
    let inclusiveAmount = parsedExlusiveAmount + (parsedExlusiveAmount * vatPercent) / 100;

    return _.round(parseFloat(inclusiveAmount), 2);
};

const removeVat = (inclusiveAmount, vatRate) => {
    if (inclusiveAmount === 0) {
        return 0;
    }

    const vatPercent = vatRate ?? defaultVatPercent;
    let parsedInclusiveAmount = parseFloat(inclusiveAmount);
    let exlusiveAmount = (parsedInclusiveAmount * 100) / (100 + vatPercent);

    return _.round(parseFloat(exlusiveAmount), 2);
};

const determineVat = (inclusiveAmount, vatRate) => {
    if (inclusiveAmount === 0) {
        return 0;
    }

    const vatPercent = vatRate ?? defaultVatPercent;
    let parsedInclusiveAmount = parseFloat(inclusiveAmount);
    let exlusiveAmount = (parsedInclusiveAmount * 100) / (100 + vatPercent);

    return _.round(parseFloat((parsedInclusiveAmount - exlusiveAmount)), 2);
};

const formatNumberAsCurrency = number => {
    if (!number) {
      return "R 0.00";
    }
    
    return number.toLocaleString('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
    });
};

export const financeHelper = {
    addVat,
    removeVat,
    determineVat,
    formatNumberAsCurrency,
};
